<template>
  <div>
    <div v-if="media.type === 'folder'" role="button" class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center">
      <i :class="'fas fa-' + size + 'x ' + getMediaThumbnail()" style="visibility: hidden;"></i>
    </div>

    <div v-if="media.type === 'file'" role="button" class="d-flex align-items-center justify-content-center"
    :class="isImage() || isSVG() ? 'py-0' : 'py-2 text-primary'">
      <img v-if="isImage()" :src="media.url.download" alt=""
      :style="{ 'max-height': isInCollection ? '75px' : '150px', 'width': 'auto', 'margin-top': isInCollection ? '0' : '20px' }">
      <inline-svg v-else-if="isSVG()" :src="media.url.download" :style="{ 'max-height': isInCollection ? '75px' : '150px', 'width': '100vw' }"/>
      <i v-else :class="'fas fa-' + size + 'x ' + getMediaThumbnail()"></i>
    </div>

    <div v-if="media.type === 'video'" role="button" class="card-img-top py-0">
      <img :src="getMediaThumbnail()" :alt="$t('network.mediaTypes.video')" :style="{ height: isInCollection ? '' : '150px', 'width': '100vw' }"/>
    </div>

    <div v-if="media.type === 'collection'" role="button" class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center">
      <i :class="'fas fa-' + size + 'x ' + getMediaThumbnail()"></i>
    </div>
  </div>
</template>
<script>
import MediaThumbnailGenerator from '@/services/MediaThumbnailGenerator.js';
import InlineSvg from 'vue-inline-svg';

export default {
  components: {
    InlineSvg,
  },
  props: {
    media: {
      type: Object,
      default: null,
    },
    isInCollection: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    getMediaThumbnail() {
      return new MediaThumbnailGenerator(this.media).getThumbnail();
    },
    getFileExtension() {
      const download = this.media?.url?.download;
      if (!download) return '';
      return download.split('#').shift().split('?').shift().split('/').pop().split('.').pop().toLowerCase();
    },
    isImage() {
      const extension = this.getFileExtension();
      return ['jpg', 'jpeg', 'png', 'gif'].includes(extension);
    },
    isSVG() {
      return this.getFileExtension() === 'svg';
    },
  },
};
</script>
